export default "__VITE_ASSET__csdvwEHr__"